import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Header } from 'semantic-ui-react';

const HomeHeaderHeadings = ({ heading, compact }) => {
  const intl = useIntl();
  return (
    <>
      <Header
        as="h2"
        className={clsx('tc white', compact ? 'four-lines-text' : 'two-lines-text')}
        content={heading}
      />
      <Header.Subheader
        as="h3"
        className="tc white mt-10"
        content={intl.formatMessage({ id: 'home.banner.sub.header' })}
      />
    </>
  );
};

export default HomeHeaderHeadings;
